<template>
  <div>
    <a-form-model
      id="verfiCodeLogin"
      ref="verfiCodeLogin"
      style="width: 100%; margin: 0 auto; padding: 20px 0 0"
      :model="form"
      :rules="rules"
      class="login-form"
      @submit="handleSubmit"
    >
      <a-form-model-item prop="phone">
        <div class="formItem">
          <a-input v-model.trim="form.phone" size="large" :placeholder="$t('请输入手机号')" />
        </div>
      </a-form-model-item>

      <a-form-model-item prop="verifyCode">
        <div style="display: flex; font-size: 12px">
          <a-input
            v-model.trim="form.verifyCode"
            :placeholder="$t('请输入短信验证码')"
            size="large"
            style="margin-right: 10px"
          />
          <a-button class="verifyCode" size="large" :disabled="state.smsSendBtn" :loading="!turnstileToken && !turnstileError" @click="sendCode">
            {{ (!state.smsSendBtn && `${$t('点击发送验证码')}`) || state.time + ' s' }}
          </a-button>
        </div>
      </a-form-model-item>

      <!-- Cloudflare Turnstile 隐式挑战容器 -->
      <div id="turnstile-login-container" style="margin-bottom: 8px" />

      <a-form-model-item prop="agreement">
        <div class="agreement-container">
          <a-checkbox v-model="form.agreement">
            <span style="font-size: 12px !important">
              {{ $t('勾选表示您同意并愿意遵守云展动力平台以下协议政策') }}：
              <router-link to="/agreement/service" target="_blank">{{ $t('云展动力平台服务协议') }}</router-link>
              <router-link to="/privacy" target="_blank">{{ $t('法律声明与隐私权政策') }}</router-link>
              <router-link to="/copyright-legal-disclaimer" target="_blank">{{ $t('版权政策与法律说明') }}</router-link>
            </span>
          </a-checkbox>
        </div>
      </a-form-model-item>

      <a-form-model-item>
        <a @click="switchTabs('findPwd')">{{ $t('找回密码') }}?</a>
        <a-button
          size="large"
          type="primary"
          html-type="submit"
          class="login-form-button"
          :loading="loading"
          style="margin-bottom: 20px"
          :disabled="!form.agreement"
          @click="handleSubmit"
        >
          {{ $t('登录') }}
        </a-button>
      </a-form-model-item>

      <div style="font-size: 18px; text-align: center">
        <span>{{ $t('还没有账号') }}</span>
        <a @click="switchTabs('register')">{{ $t('立即注册') }}</a>
      </div>
      <a-divider>
        <span style="color: #717171">{{ $t('其他登录方式') }}</span>
      </a-divider>
      <v-img
        :src="ICON_WENXIN"
        alt="微信"
        width="60"
        style="
          width: 60px;
          left: 50%;
          position: relative;
          transform: translate(-50%, 0);
          cursor: pointer;
          margin-bottom: 20px;
        "
        @click="switchTabs('wechatLogin')"
      />
    </a-form-model>
    <vImgCode v-if="imgCodeFlag" :visible.sync="imgCodeFlag" :phone="form.phone" :emitCodeOnly="true" @confimCode="confimCode" />
  </div>
</template>

<script>
import vImgCode from '@/components/business/imgCodeValidate.vue'

import { ICON_WENXIN } from '@/const/image'

import { sendSmsLoginCode, smsLogin, firstLogin } from '@/api/login'
import { loadTurnstileScript, renderTurnstile, resetTurnstile, removeTurnstile } from '@/utils/turnstile'

export default {
  name: 'VerifiCodeLogin',
  components: {
    vImgCode,
  },
  props: {
    // 弹窗登录或注册时传入reload 刷新当前页
    backPath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      ICON_WENXIN,
      form: {
        phone: '',
        verifyCode: '',
        agreement: false, // 新增协议同意字段
      },
      rules: {
        phone: [
          {
            required: true,
            message: this.$t('请输入手机号'),
            whitespace: true,
          },
          {
            // 如果需要手机号格式验证
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t('请输入正确的手机号'),
            trigger: 'blur',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: this.$t('请输入短信验证码'),
            whitespace: true,
          },
          {
            pattern: /^\d{4,6}$/,
            message: this.$t('验证码格式不正确'),
            trigger: 'blur',
          },
        ],
        agreement: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t('请阅读并同意相关协议')))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
      state: {
        time: 120,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000',
      },
      isPhone: false,
      isPhoneText: '',
      imgCodeFlag: false,
      registerBtn: false,
      // Turnstile widget ID
      turnstileWidgetId: null,
      // Turnstile 验证成功后的 token
      turnstileToken: '',
      // Turnstile 是否加载失败（用于降级）
      turnstileError: false,
    }
  },
  async mounted() {
    // 加载 Turnstile SDK 并渲染 widget（自动验证，验证成功后才可发送验证码）
    try {
      await loadTurnstileScript()
      this.turnstileWidgetId = renderTurnstile('#turnstile-login-container', {
        onSuccess: (token) => {
          this.turnstileToken = token
        },
        onExpired: () => {
          this.turnstileToken = ''
          // token 过期后自动重新验证
          if (this.turnstileWidgetId) {
            resetTurnstile(this.turnstileWidgetId)
          }
        },
        onError: () => {
          this.turnstileToken = ''
        },
      })
    } catch (error) {
      console.error('[verifiCodeLogin] Turnstile 初始化失败:', error)
      this.turnstileError = true
    }
  },
  beforeDestroy() {
    // 清理 Turnstile widget
    if (this.turnstileWidgetId) {
      removeTurnstile(this.turnstileWidgetId)
    }
  },
  methods: {
    // 发送验证码（含 Turnstile 防刷）
    async sendCode(flag = true) {
      const {
        form: { phone },
        state,
        $message,
        $notification,
      } = this
      console.log('form', this.form)

      this.$refs.verfiCodeLogin.validateField('phone')

      if (!phone) {
        $message.error(`${this.$t('请输入手机号')}`)
        return
      }
      state.smsSendBtn = true
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 120
          state.smsSendBtn = false
          window.clearInterval(interval)
        }
      }, 1000)
      console.log('验证码发送中1', flag)
      if (flag) {
        // 如果 Turnstile 未加载成功，且处于错误状态，降级使用图形验证码
        if (!this.turnstileToken && this.turnstileError) {
          this.imgCodeFlag = true
          return
        }

        const hide = $message.loading(this.$t('验证码发送中'), flag ? 0 : 1000)

        // 使用已验证的 Turnstile token（按钮在 token 就绪前已禁用）
        const cfTurnstileToken = this.turnstileToken

        const { code } = await sendSmsLoginCode({ phone, cfTurnstileToken })
        console.log('获取验证码响应', code)

        // 重置 Turnstile（清除已用 token，重新验证以备下次使用）
        this.turnstileToken = ''
        if (this.turnstileWidgetId) {
          resetTurnstile(this.turnstileWidgetId)
        }

        if (code === 0 || code === 200) {
          setTimeout(hide, 2000)
          $notification.success({
            message: this.$t('提示'),
            description: this.$t('验证码发送成功,请注意查看'),
            duration: 8,
          })
        } else {
          setTimeout(hide, 1)
          clearInterval(interval)
          state.time = 120
          state.smsSendBtn = false
        }
      }
    },
    // 处理图形验证码的回调（降级模式发送短信）
    async confimCode(imgCode) {
      const {
        form: { phone },
        state,
        $message,
        $notification,
      } = this

      const hide = $message.loading(this.$t('验证码发送中'), 0)
      
      const { code, msg } = await sendSmsLoginCode({ 
        phone, 
        cfTurnstileToken: '', 
        imgCode 
      })

      setTimeout(hide, 1)

      if (code === 0 || code === 200) {
        this.imgCodeFlag = false
        $notification.success({
          message: this.$t('提示'),
          description: this.$t('验证码发送成功,请注意查看'),
          duration: 8,
        })
      } else {
        $notification.error({
          message: this.$t('提示'),
          description: msg || this.$t('验证码发送失败'),
        })
        // 图形验证码错误时，停留在弹窗状态，等待用户刷新图形验证码重试
        clearInterval(window.interval) // 清除 sendCode 里设置的定时器
        state.time = 120
        state.smsSendBtn = false
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.$refs.verfiCodeLogin.validate(async (valid) => {
        if (valid) {
          this.loading = true

          const { code, data, msg } = await smsLogin({
            phone: this.form.phone,
            verifyCode: this.form.verifyCode,
          })

          console.log('登录响应', code, data, msg)
          this.loading = false
          if (code === 0) {
            this.$store.commit('switchPopupLoginStatus', false)

            // 如果当前页面是 /aiSystemRecommend 判断是否第一次登录
            if (this.$route.path === '/aiSystemRecommend') {
              const res = await firstLogin()
              if (!res.data) {
                this.$store.commit('SET_LOGIN_COOKIE', {
                  token: data.access_token,
                  refreshToken: data.refresh_token,
                })

                await this.$store.dispatch('getUserInfo')
                this.$router.push('/firstLogin')
                return
              }
            }
            // 判断是否第一次登录 结束

            // 前置路由地址跳转判断
            const backPath = this.backPath
            let url = ''
            if (backPath) {
              this.$store.commit('SET_LOGIN_COOKIE', {
                token: data.access_token,
                refreshToken: data.refresh_token,
              })

              if (backPath.includes('/register') || backPath.includes('/findPwd')) {
                url = '/'
              } else {
                url = backPath || '/'
              }
            } else {
              url = this.$store.getters.getConsolePath
            }

            if (backPath === 'reload') {
              this.$router.go(0)
            } else {
              await this.$store.dispatch('getUserInfo')
              this.$router.push(url)
            }
          } else {
            this.$notification.error({
              message: this.$t('获取会员信息失败'),
              description: '服务器错误,请稍候再试',
            })
          }
        }
      })
    },

    switchTabs(e) {
      this.$emit('switchTabs', e)
    },
  },
}
</script>
<style lang="scss" scoped>
.login-form {
  max-width: 450px;
  margin: auto;
}

.formItem {
  position: relative;
}

.login-form-forgot {
  float: right;
}

.login-form-button {
  width: 100%;
}
</style>
